import { getPortalSdk } from 'portal-sdk';
import { isPortal } from 'vet-bones/utils/portal';

import { connectionsSlice } from 'src/store/connections/connections.slice';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const refreshConnectionToken =
  () => async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const { connections } = getState();
    const { connection: currentConnection } = connections;

    if (!isPortal() || !currentConnection?.token) {
      return null;
    }
    const sdk = getPortalSdk();
    if (!sdk) {
      return null;
    }

    const updatedConnection = await sdk.getConnectionByIndex(
      currentConnection.index
    );

    if (!updatedConnection?.token) {
      return null;
    }

    dispatch(
      connectionsSlice.actions.updatedConnectionToken({
        token: updatedConnection.token,
      })
    );

    return { ...currentConnection, token: updatedConnection.token };
  };
